import { Header } from "components/atoms/Typography";
import { useState } from "react";
import classNames from "classnames";
import { Button } from "components/atoms/Button";
import ImpactCards from "./ImpactCards";
import TotalCostAndSavingsCard from "./TotalCostAndSavingsCard";
import CashFlowChartWrapper from "./CashFlowChartWrapper";
import MeasureAnalysis from "../MeasureAnalysis";

interface FinancialImpactProps {
    measure: CarbonReductionMeasure;
}

export function FinancialImpact({ measure }: FinancialImpactProps) {
    const [selectedView, setSelectedView] = useState<"total" | "incremental">("total");
    const measureAnalysis =
        selectedView === "total" ? measure.totalMeasureAnalysis : measure.incrementalMeasureAnalysis;

    return (
        <div className="financial-impact project-report__section">
            <div className="financial-impact__header">
                <Header size="medium">Financial impact</Header>
                <SelectedViewTab
                    selected={selectedView === "incremental"}
                    title="Incremental"
                    onSelect={() => setSelectedView("incremental")}
                />
                <SelectedViewTab
                    selected={selectedView === "total"}
                    title="Total"
                    onSelect={() => setSelectedView("total")}
                />
            </div>
            {/* eslint-disable-next-line */}
            {measureAnalysis ? (
                <MeasureAnalysis measure={measure} measureAnalysis={measureAnalysis!} />
            ) : (
                <>
                    <ImpactCards measure={measure} selected={selectedView} />
                    <div>
                        <TotalCostAndSavingsCard selectedView={selectedView} measure={measure} />
                        <CashFlowChartWrapper measure={measure} selected={selectedView} />
                    </div>
                </>
            )}
        </div>
    );
}

interface SelectedViewTabProps {
    selected: boolean;
    title: string;
    onSelect: () => void;
}

function SelectedViewTab({ selected, title, onSelect }: SelectedViewTabProps) {
    return (
        <Button className={classNames("select-view-tab", selected && "selected")} onClick={onSelect}>
            {title}
        </Button>
    );
}
